import React, { useState, useEffect, useRef } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import ERPSBaseButton from "../custom/inputs/ERPSBaseButton";
import ERPSBaseLink from "../custom/inputs/ERPSBaseLink";
import { marketManagementAction } from "../../actions/marketingManagement.action";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationMessage from "../custom/containers/ConfirmationMesssage";
import ErrorMessage from "../custom/containers/ErrorMessage";
import parse from "html-react-parser";
import { validateURL } from "../../utils/helper";
import CommonContainerBox from "../custom/containers/CommonContainerBox";
import { Card, CardContent, HStack, ResponsiveBox, Stack, Typography } from "../primitives";
import { useMainContentFocus } from "../../hooks";

function DashboardPendingApproval(props) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const loginUser = useSelector((state) => state.loginUserReducer?.user);
  const selectedFi = useSelector((state) => state.fiReducer?.selectedFi);

  const fiNumber = selectedFi || loginUser.user?.fiNumber;

  const successRef = useRef(null);
  const errorRef = useRef(null);

  const successMessage = useSelector(
    (state) => state.marketingManagementReducer?.approveDashboardMessage
  );
  const errorMessage = useSelector(
    (state) => state.marketingManagementReducer?.approveDashboardError
  );
  const getDashboardErrorMessage = useSelector(
    (state) => state.marketingManagementReducer?.getDashboardError
  );
  const getDashboardMessage = useSelector(
    (state) => state.marketingManagementReducer?.getDashboardQueueMessage
  );
  const [showExceptionMessage, setShowExceptionMessage] = useState(false);

  const [declineLoading, setDeclineLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);

  const [showSuccessMessage, setSuccessMessage] = useState(false);
  
  // Use the custom hook for focus management - WCAG 2.4.3 Focus Order compliance
  const { mainContentRef } = useMainContentFocus({
    isReady: getDashboardMessage !== null && getDashboardMessage !== undefined,
    dependencies: [getDashboardMessage, showExceptionMessage],
    delay: 100,
  });

  useEffect(() => {
    if (successRef.current) {
      successRef.current.focus();
    }
  }, [successMessage && showSuccessMessage]);

  const [messagesList, setMessagesList] = useState([
    {
      en: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 1,
        type: t("erps.header.language.english_label"),
      },
      fr: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 1,
        type: t("erps.header.language.french_label"),
      },
      messageId: 1,
    },
    {
      en: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 2,
        type: t("erps.header.language.english_label"),
      },
      fr: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 2,
        type: t("erps.header.language.french_label"),
      },
      messageId: 2,
    },
    {
      en: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 3,
        type: t("erps.header.language.english_label"),
      },
      fr: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 3,
        type: t("erps.header.language.french_label"),
      },
      messageId: 3,
    },
  ]);

  useEffect(() => {
    dispatch(
      marketManagementAction.getDashboardQueueMessage({ setShowExceptionMessage })
    );
  }, []);

  useEffect(() => {
    if (getDashboardMessage && getDashboardMessage.length) {
      let dataV1 = [];
      getDashboardMessage.forEach((data) => {
        dataV1.push({
          en: {
            header: data?.messageHeaderEnglish,
            message: data?.messageTextEnglish,
            urlText: data?.messageLinkTextEnglish,
            urlLink: data?.messageUrlEnglish,
            type: t("erps.header.language.english_label"),
          },
          fr: {
            header: data?.messageHeaderFrench,
            message: data?.messageTextFrench,
            urlText: data?.messageLinkTextFrench,
            urlLink: data?.messageUrlFrench,
            type: t("erps.header.language.french_label"),
          },
          messageId: data?.id,
        });
      });
      setMessagesList(dataV1);
    }
  }, [getDashboardMessage]);

  const handleDecline = () => {
    setDeclineLoading(true);
    setShowExceptionMessage(false);
    dispatch(
      marketManagementAction.dashboardPendingDeclineMessage({
        setLoading: setDeclineLoading,
        setSuccessMessage,
        setShowExceptionMessage,
      })
    );
  };

  const handleApprove = () => {
    setApproveLoading(true);
    setShowExceptionMessage(false);
    dispatch(
      marketManagementAction.dashboardPendingApprovalMessage({
        data: getDashboardMessage,
        setLoading: setApproveLoading,
        setSuccessMessage,
        setShowExceptionMessage,
      })
    );
  };

  const getCardComponent = (lan) => {
    const messagesContent = messagesList.map((data) => data[lan]);

    return (
      <>
        <ResponsiveBox mb={2}>
          <Typography variant="h3">
            {lan === "en"
              ? t("erps.header.language.english_label")
              : t("erps.header.language.french_label")}
          </Typography>
        </ResponsiveBox>
        <Card className="messageCenter__card__container">
          <CardContent>
            <Typography
              variant="h2"
              className="messageCenter__card__content__header"
            >
              {t("erps.login.message.card.title", "Messages")}
            </Typography>
            {messagesContent.map(
              ({ header, message, urlText, urlLink }, idx) => (
                <ResponsiveBox mt={2}>
                  {header && (
                    <Typography
                      variant="h3"
                      className="messageCenter__card__content__heading"
                    >
                      {header}
                    </Typography>
                  )}
                  <Typography
                    variant="body1"
                    className="signIn__card__content__header"
                  >
                    {message ? parse(message) : ""}
                    {message && <br />}
                    {(urlText || urlLink) && (
                      <ERPSBaseLink
                        label={urlText || urlLink}
                        to={{
                          pathname: !validateURL(urlLink)
                            ? `http://${urlLink}`
                            : urlLink,
                        }}
                        target={"_blank"}
                        className="signIn__card__content__link"
                      />
                    )}
                  </Typography>
                </ResponsiveBox>
              )
            )}
          </CardContent>
        </Card>
      </>
    );
  };
  const handleCloseSuccessMessage = () => {
    props?.history?.push("/manage-message-centre");
  };
  return (
    <main ref={mainContentRef}>
      <ResponsiveBox ml={3} mt={2}>
        {successMessage && showSuccessMessage && (
          <ConfirmationMessage
            message={successMessage}
            setShowMessage={setSuccessMessage}
            inputRef={successRef}
            handleClose={handleCloseSuccessMessage}
            ariaText={t(
              "erps.marketingManagement.message.confirmationmessage.redirectiontext"
            )}
          />
        )}
        <ResponsiveBox mt={4}>
          {/* For Title update */}
          <CommonContainerBox title={t("erps.marketingManagement.manageMessageCenterPendingApproval.heading")} />
          <Typography variant="h1">
            {t(
              "erps.marketingManagement.manageMessageCenterPendingApproval.heading"
            )}
          </Typography>
        </ResponsiveBox>
        <ResponsiveBox mt={3}>
          <Typography variant="body1">
            {(getDashboardMessage && getDashboardMessage.length) ||
            (showExceptionMessage && (errorMessage || getDashboardErrorMessage))
              ? t(
                  "erps.marketingManagement.manageMessageCenterPendingApproval.subheading"
                )
              : t("erps.marketingManagement.nopendingapprovals")}
          </Typography>
        </ResponsiveBox>
        <ErrorMessage
          error={showExceptionMessage || errorMessage || getDashboardErrorMessage ? (errorMessage || getDashboardErrorMessage) : null}
          errorRef={errorRef}
          mt={2}
        />
          <>
            <ResponsiveBox>{getCardComponent("en")}</ResponsiveBox>
            <ResponsiveBox mt={3} mb={2}>
              {getCardComponent("fr")}
            </ResponsiveBox>
            <HStack spacing={2}>
              <ERPSBaseButton
                variant="secondary"
                onClick={handleDecline}
                loading={declineLoading}
                className="button_with_margin48"
                isDisabled={
                  showSuccessMessage &&
                  (loginUser?.userId == getDashboardMessage?.[0]?.updatedBy ||
                    successMessage)
                }
                label={t("erps.common.button.reject")}
              />
              <ERPSBaseButton
                variant="primary"
                onClick={handleApprove}
                loading={approveLoading}
                className="button_with_margin48"
                label={t("erps.common.button.approve")}
                isDisabled={
                  loginUser?.userId == getDashboardMessage?.[0]?.updatedBy ||
                  (successMessage && showSuccessMessage)
                }
              />
            </HStack>
          </>
      </ResponsiveBox>
    </main>
  );
}
export default withSidebar(DashboardPendingApproval);
